import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "arrow-left-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.89861 18.9537C9.19163 19.2464 9.66651 19.2462 9.95927 18.9532C10.252 18.6602 10.2518 18.1853 9.95881 17.8925L4.81193 12.7501L21 12.7501C21.4142 12.7501 21.75 12.4143 21.75 12.0001C21.75 11.5859 21.4142 11.2501 21 11.2501L4.81191 11.2501L9.95881 6.10771C10.2518 5.81494 10.252 5.34007 9.95927 5.04705C9.66651 4.75403 9.19163 4.75382 8.89861 5.04659L2.47858 11.461C2.33763 11.5974 2.25 11.7885 2.25 12.0001C2.25 12.212 2.33781 12.4033 2.47901 12.5396L8.89861 18.9537Z" }, null, -1)
  ])))
}
export default { render: render }